export default "data:image/gif;base64,R0lGODlhEgAMAPEAAP///wAA//8AAAAAACH5BAAAAAAALAAAAAASAAwAAAIcjAGmy5eOopyo2QrpC9guDUbeyIUg6Zkn2qhaAQA7"